module.exports = __webpack_public_path__ + "static/media/CenturyGothic.69c31fd5.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/CenturyGothic.eot
// module id = 3
// module chunks = 0